<div class="itsl-empty-state-informative-card">
    <div class="itsl-empty-state-informative-card__content-container">
        <h2 class="itsl-empty-state-informative-card__title">
            {config.hasAnyPlan ? lang.main("Planner2_YouHaveNothingPlanned") : lang.main("Planner2_GetStartedWithPlans")}
        </h2>
        <p class="itsl-empty-state-informative-card__description">
            {config.hasAnyPlan ? lang.main("Planner2_PlansWithoudDate_EmptyState")
            : lang.main("Planner2_CreateBetterStructure_PlanEmptyState")}
        </p>
        <ButtonGroup>
            {#if config.hasAnyPlan}
                <Link
                    kind="primary-standalone"
                    text={lang.main("Planner2_ShowAllPlans")}
                    href={config.plannerWithoutDateUrl}
                />
            {:else}
                <Link
                    kind="primary-standalone"
                    text={lang.main("Plans2_CreatePlan")}
                    href={createNewPlanUrl}
                    on:click={createNewPlan}
                />
            {/if}
            {#if config.isImportEnabled}
                <UseReadyMadeContentLink
                    href={`/Courses/${config.courseId}/ImportContent?importTopic=false&fromOverview=${fromOverview}&returnUrl=${encodeURIComponent(window.location.href)}`}
                    linktext={lang.main("Planner2_UseReadyMadeContent")}
                ></UseReadyMadeContentLink>
            {/if}
            <Link
                kind="standalone"
                href={howPlansWorkHref}
                target="_blank"
                text={lang.main("Planner2_HowPlanWorks")}
                on:click={measureHowPlansWorkLinkEmptyState}
            />
        </ButtonGroup>
    </div>
    <div class="itsl-empty-state-informative-card__image-container">
        <span class="itsl-empty-state-informative-card__image {imgCssClass}"></span>
    </div>
</div>
<script>
    import ButtonGroup from "@itslearning/prometheus/assets/inputs/ButtonGroup/v1/ButtonGroup.svelte";
    import Link from "@itslearning/prometheus/assets/navigation/Link/v1/Link.svelte";

    import UseReadyMadeContentLink from "../UseReadyMadeContentLink/UseReadyMadeContentLink.svelte";

    import { lang } from "@its-ui/mono/lang/provider";
    import { createPlan, createPlanV2 } from "@its-ui/planner-common/api";
    import { postNewPlannerKpi } from "@its-ui/planner-common/helpers/kpiHelper";
    import config from "../../config";

    export let fromOverview;
    export let backLink;

    const supportedLinkLanguages = ["sv", "de", "da", "nl", "no", "fi"];
    const howPlansWorkHref = getHowPlansWorkHref();

    let createNewPlanUrl = "#";
    let imgCssClass = config.hasAnyPlan ? `itsl-empty-state-informative-card__image--nodateplans` : `itsl-empty-state-informative-card__image--noplans`;

    async function createNewPlan(event) {
        event.stopPropagation();
        event.preventDefault();

        const planParams = {
            topic: null,
            start: "0000-00-00 00:00:00",
            stop: "0000-00-00 00:00:00"
        };

        const newPlan = config.assignToEnabled ? await createPlanV2(planParams) : await createPlan(planParams);

        createNewPlanUrl = `${config.newPlanUrl}/${newPlan.planId}?pendingPlanId=${newPlan.planId}&BackDestination=${backLink}`;
        window.location.href = createNewPlanUrl;

        return false;
    }

    function measureHowPlansWorkLinkEmptyState() {
        postNewPlannerKpi(config.kpi.kpiMeasurementHowPlansWorkLinkEmptyState);
    }

    function getHowPlansWorkHref() {
        const rawCode = (config.lang.currentCultureName).toLowerCase();
        let shortCode = rawCode.split("-")[0];

        if (shortCode === "nb" || shortCode === "nn") {
            shortCode = "no";
        }

        const subdomain = supportedLinkLanguages.includes(shortCode)
            ? `${shortCode}.`
            : ""; // default to English

        return `https://${subdomain}itslearning.com/learn/get-started-with-plans`;
    }
</script>